import { axios, axiosNew } from "../middleware";
import { getFormData } from "helpers/convertFormData";
import type { LoginUser, SignupUser, UserProfileFormData } from "models/User";
import { IDeleteAccount } from "models/UserSetting";

//confirm invited carrier
export const confirmInvitationAPI = async (inviteToken: string) => {
  return axios.get("/groups/invite/confirm/", {
    params: { invite_token: inviteToken, create_relation: false, send_update_email: true }
  });
};

//signin
export const loginAPI = async (params: LoginUser) => {
  return axios.post("/o/token/", getFormData(params));
};

//reset password
export const resetPasswordAPI = async (email: string | undefined) => {
  return axios.post(`/user/password/reset/`, {
    email: email,
    app_name: "haulpay_customer"
  });
};

//actually update the user's password
export const updateUserPasswordAPI = async (resetPasswordToken: string, password: string) => {
  return axios.post("/user/password/reset/confirm/", {
    reset_password_token: resetPasswordToken,
    new_password: password
  });
};

//signup
export const signupAPI = async (data: SignupUser, source?: string) => {
  return axios.post("/users/", data, {
    params: source ? { source } : undefined
  });
};

export const checkEmailExistAPI = async (email: string) => {
  return axios.get(`/user/check_exists?email=${email}`);
};

export const checkTransIdAPI = async (transType: string, transId: number) => {
  return axios.get("/factoring/fmcsa/", { params: { [transType]: transId } });
};

//get current user
export const getCurrentUserAPI = async () => {
  return axios.get("/user/current");
};

//get user permission
export const getUserPermissionAPI = async (userId: string) => {
  return axios.get(`/user/${userId}/details/`);
};

export const getAccountAPI = async (userId: string) => {
  return axios.get(`/users/${userId}/`);
};

//update user profile
export const updateAccountAPI = async (
  userType: string,
  userId: string,
  data: Record<string, any>
) => {
  return axios.patch(`/${userType}s/${userId}/`, data);
};

export const updateSignUpDetails = async (userId: string, data: any) => {
  return axios.patch(`/users/${userId}/`, data);
};

//get user by FMCSA number
export const getUserByFmcsaAPI = async (params: any) => {
  return axios.get(`/factoring/fmcsa/`, { params });
};

//update user profile
export const updateUserProfileAPI = async (
  userId: string,
  type: string,
  params: UserProfileFormData
) => {
  return axios.patch(`/${type}s/${userId}/`, getFormData(params));
};

//update user email
export const updateUserEmailAPI = async (userId: string, email: string) => {
  return axios.patch(`/users/${userId}/`, { email });
};

export const createInvitedUserAPI = async (invite_token: string, data: any) => {
  return axiosNew.post("users/", data, {
    params: { invite_token }
  });
};

export const getInvitedGroupsAPI = async (status: "connected" | "pending") => {
  return axios.get(`groups/invited/${status}/`);
};

export const getStripeAccountAPI = async () => {
  return axios.get("cmftstripe/account");
};

export const updateUserDetails = async (userId: string, data: any) => {
  const options = {
    url: `/user/${userId}/details/`,
    method: "PATCH",
    data
  };
  return axios(options);
};

export const uploadFirebaseToken = async (firebaseToken: string) => {
  const options = {
    url: `/activity/device/`,
    method: "POST",
    data: {
      token: firebaseToken
    }
  };
  return axios(options);
};

export const deleteAccountAPI = async (data: IDeleteAccount) => {
  return axios.post("help/", data);
};
